// src/components/AdminLayout.tsx
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/originelogo.png";
import "./index.css";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const nav = useNavigate()
  async function logout() {
      try {
        await signOut(auth);
      } finally {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        nav("/login", { replace: true });
      }
    }
    
  return (
    <div className="admin">
      <header className="admin__top">
        <img src={logo} className="login__logo" />
        <nav className="admin__nav">
          <NavLink to="/admin" className="admin__link">Главная</NavLink>
          <NavLink to="/admin/formulas" className="admin__link">Формулы</NavLink>
          <NavLink to="/admin/production" className="admin__link">Производство</NavLink>
          <NavLink to="/admin/pack" className="admin__link">Упаковка</NavLink>
          <NavLink to="/admin/shipping" className="admin__link">Доставка</NavLink>
          <div onClick={logout} className="admin__link">Выйти</div>
        </nav>
      </header>

      <main className="admin__main">{children}</main>
    </div>
  );
}
